import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTv, FiRadio, FiMonitor, FiSettings, FiTool, FiTrash2 } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiTv,
      title: 'Aerial Extensions',
      description: 'Professional aerial extensions for better signal reception'
    },
    {
      icon: FiRadio,
      title: 'Satellite Installation',
      description: 'Freesat and Freeview installations with new dish replacement'
    },
    {
      icon: FiSettings,
      title: 'Wide Band Aerials',
      description: 'High-quality wide band aerial installations'
    },
    {
      icon: FiMonitor,
      title: 'TV Wall Mounting',
      description: 'Secure and professional TV wall mounting services'
    },
    {
      icon: FiTool,
      title: 'Equipment Replacement',
      description: '2-year guarantee on all new equipment installations'
    },
    {
      icon: FiTrash2,
      title: 'Removal Service',
      description: 'Old aerial and satellite removal with equipment disposal'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive aerial and satellite services with professional installation and maintenance
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mb-4">
                <SafeIcon icon={service.icon} className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Service Highlights */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mt-16 bg-blue-900 text-white p-8 rounded-lg"
        >
          <h3 className="text-2xl font-bold mb-6 text-center">Service Guarantees</h3>
          <div className="grid md:grid-cols-4 gap-6 text-center">
            <div>
              <h4 className="font-semibold mb-2">Free Call Outs</h4>
              <p className="text-blue-200">No charge for quotes and assessments</p>
            </div>
            <div>
              <h4 className="font-semibold mb-2">2 Year Guarantee</h4>
              <p className="text-blue-200">All new equipment covered</p>
            </div>
            <div>
              <h4 className="font-semibold mb-2">Same Day Service</h4>
              <p className="text-blue-200">Available when you need us</p>
            </div>
            <div>
              <h4 className="font-semibold mb-2">Fully Insured</h4>
              <p className="text-blue-200">Complete peace of mind</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;